import { Access, AccessComponentEnum, AccessLevelEnum } from 'graphql-common';
import { checkUserAccessByComponent } from '@lib/utils/accesses';
import { APP_URLS } from 'constants/urls';

export default function getHomePageUrl(accesses: Access[]) {
  if (
    checkUserAccessByComponent(
      accesses,
      AccessComponentEnum.TasksPerforming,
    ) !== AccessLevelEnum.LimitedRead
  ) {
    return APP_URLS.app.tasks.index.getPathWithQuery();
  }
  if (
    checkUserAccessByComponent(
      accesses,
      AccessComponentEnum.InterventionsManagement,
    ) !== AccessLevelEnum.LimitedRead
  ) {
    return APP_URLS.app.interventions.index.getPathWithQuery();
  }
  return APP_URLS.app.profile.path;
}
